import { render } from "./ProductGridComponent.vue?vue&type=template&id=2c002cf6&scoped=true"
import script from "./ProductGridComponent.vue?vue&type=script&lang=js"
export * from "./ProductGridComponent.vue?vue&type=script&lang=js"

import "./ProductGridComponent.vue?vue&type=style&index=0&id=2c002cf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c002cf6"]])

export default __exports__